import { Component, OnInit } from '@angular/core';
import { Referential } from '../models/referential';
import { ProductCategoryService } from '../rest_services/family.service';
import { Subscription } from 'rxjs';
import { ServiceResponse } from '../models/service-response';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors } from '@angular/forms';
import { SalesService } from '../rest_services/sales.service';
import { VisitService } from '../rest_services/visit.service';
import { CustomersService } from '../rest_services/customers.service';

@Component({
  selector: 'app-sales',
  templateUrl: './sales.component.html',
  styleUrls: ['./sales.component.css']
})
export class SalesComponent implements OnInit {

  advancedSearchForm: FormGroup;
  loading_sales:boolean = true;
  role:any;
  mobile:boolean=false;

  constructor(private productCategoryService:ProductCategoryService,
    private fb:FormBuilder, private salesService:SalesService, 
    private customersService:CustomersService,
    private visitService:VisitService
  ) {
    this.advancedSearchForm = this.fb.group({
        'customer': [''],
        'commercial' : [''] ,
        'sale_category' : [''] ,
        'start_date':[''],
        'end_date':['']
      },{ validators: this.dateValidator }); 
   }

   dateValidator(group: AbstractControl): ValidationErrors | null {
    const start = group.get('start_date')?.value;
    const end = group.get('end_date')?.value;
    
    if (end && !start) return { startRequired: true };
    if (start && end && end < start) return { dateInvalid: true };
    return null;
  }
  ngOnInit(): void {
    if(localStorage.getItem("role")!=undefined) {
      this.role =localStorage.getItem("role");
    }else if(sessionStorage.getItem("role")!=undefined){
      this.role =sessionStorage.getItem("role");
    }
    if (window.screen.width < 768) { // 768px portrait
      this.mobile = true;
    }else {
      this.mobile = false;
    }
    this.getAllCustomersAutocomplete();
    this.getSales();
  }
  //#region SEARCH BLOC
    areAllControlsEmpty(): boolean {
      const controls = this.advancedSearchForm.controls;   
      return Object.keys(controls).every(controlName => controls[controlName].value === '');
    }

    onKeyUp(event:any,input:any) { // appending the updated value to the variable    
      if(event.target.value.length==0) {
        this.advancedSearchForm.controls[input].setValue("");
      }
    }
    categoriesSubscription!:Subscription;
    categories: Array<any> = [];
    categoriesFiltered: Array<Referential> = [];
    getCategories(){
      var glob=this;
        this.categoriesSubscription = this.productCategoryService.getProductCategories().subscribe(
          (data: ServiceResponse) => {   
            if(data.code == "cf0e0d96d99d8cd08b9f74c6dd7c1bb8"){          
              this.categories = data.categories?data.categories:[];   
              // setTimeout(()=>{
              //   (<any>$( "#categories" )).autocomplete({
              //       source: function ( request:any, response:any ) {
              //         const results = $.map(glob.categories, function (obj, key) {
              //           var name = obj.category.toUpperCase();
              //           if (name.indexOf(request.term.toUpperCase()) != -1) {				
              //             return {
              //               label: obj.category,
              //               value: obj.uuid
              //             }
              //           } else {
              //             return null;
              //           }
              //         });

              //         // ✅ Aucun résultat → injecter un item informatif non sélectionnable
              //         if (results.length === 0) {
              //           response([{ label: 'Aucune famille', value: null, noResult: true }]);
              //         } else {
              //           response(results);
              //         }		
              //     },    
              //     focus: function(event:any, ui:any) {
              //       event.preventDefault();
              //     },
              //     // Once a value in the drop down list is selected, do the following:
              //     select: function(event:any, ui:any) {
              //       event.preventDefault();
              //       if (ui.item.noResult) return;
              //       // place the person.given_name value into the textfield called 'select_origin'...
              //       glob.advancedSearchForm.controls['sale_category'].setValue(ui.item.value);
              //       $('#categories').val(ui.item.label);
              //       // ... any other tasks (like setting Hidden Fields) go here...
              //     }
              //   });
              // }, 500);
            }
            // this.categoriesLoader=false;         
          },
          (error) => {
            console.log(error);
            // this.categoriesLoader=false;   
          }
        );
    }

    isValidUUID(uuid: string): boolean {
      const uuidPattern = /^[0-9a-f]{8}-([0-9a-f]{4}-){3}[0-9a-f]{12}$/i;
      return uuidPattern.test(uuid);
    }

    refClients:any[] =[];
    getAllCustomersAutocomplete(){
      var glob=this;
      this.customersService.getAllCustomersAutocomplete();
      this.customersService.customersSubject.subscribe(
        ( data: any ) => {
          if(data.code=="a12d89f623abb138ebacc91b3703326a" && data.customers !=null){
            var newArrayAllCustomers:any[] = [];
            for(let cust of data.customers){
              var customer = {
                rs_customer:cust.customer_rs,
                uuid:cust.customer,
              }
              newArrayAllCustomers.push(customer);
            }
            setTimeout(()=>{
              this.refClients = newArrayAllCustomers;
              (<any>$( "#customers" )).autocomplete({
                source: function ( request:any, response:any ) {
                  const results = $.map(glob.refClients, function (obj, key) {
                    var name = obj.rs_customer.toUpperCase();
                    if (name.indexOf(request.term.toUpperCase()) != -1) {				
                      return {
                        label: obj.rs_customer,
                        value: obj.uuid
                      }
                    } else {
                      return null;
                    }
                  });

                  // ✅ Aucun résultat → injecter un item informatif non sélectionnable
                  if (results.length === 0) {
                    response([{ label: 'Aucun client', value: null, noResult: true }]);
                  } else {
                    response(results);
                  }		
                },    
                focus: function(event:any, ui:any) {
                  event.preventDefault();
                },
                // Once a value in the drop down list is selected, do the following:
                select: function(event:any, ui:any) {
                  event.preventDefault();
                  if (ui.item.noResult) return;
                  // place the person.given_name value into the textfield called 'select_origin'...
                  glob.advancedSearchForm.controls['customer'].setValue(ui.item.value);             
                  $('#customers').val(ui.item.label);
                  // ... any other tasks (like setting Hidden Fields) go here...
                }
              });
            }, 1000);
          }
          
        },
      )  
    }
    ourTeam:any[]=[]
    getCommercials(){
      var glob=this;
      this.visitService.getCommercialsToAffect();
      this.visitService.commercialsSubject.subscribe(
        ( data: any ) => {
          if(data.code=="b1f37eec383fcada527079602ac178b3"){          
            this.ourTeam = data.commercials;
            setTimeout(()=>{
            (<any>$( "#commercials" )).autocomplete({
                source: function ( request:any, response:any ) {
                  const results = $.map(glob.ourTeam, function (obj, key) {
                    var name = obj.commercial.toUpperCase();
                    if (name.indexOf(request.term.toUpperCase()) != -1) {				
                      return {
                        label: obj.commercial,
                        value: obj.commercial_uuid
                      }
                    } else {
                      return null;
                    }
                  });

                  // ✅ Aucun résultat → injecter un item informatif non sélectionnable
                  if (results.length === 0) {
                    response([{ label: 'Aucun commercial', value: null, noResult: true }]);
                  } else {
                    response(results);
                  }			
              },    
              focus: function(event:any, ui:any) {
                event.preventDefault();
              },
              // Once a value in the drop down list is selected, do the following:
              select: function(event:any, ui:any) {
                event.preventDefault();
                if (ui.item.noResult) return;
                // place the person.given_name value into the textfield called 'select_origin'...
                glob.advancedSearchForm.controls['commercial'].setValue(ui.item.value);
                $('#commercials').val(ui.item.label);
                // ... any other tasks (like setting Hidden Fields) go here...
              }
            });
            }, 1000);
          }
        },
      )  
    }
  //#endregion

  //#region SEARCH CONTENT
    salesData:any[]=[];
    salesDataFiltred:any[]= [];
    salesSubscription!: Subscription;
    loading_actions_search:boolean=false;
    getSales(){
      this.salesSubscription = this.salesService.getAllSales().subscribe(
        (data: any) => {    
          this.salesData = data.sales;
          this.salesDataFiltred = data.sales  
          this.loading_sales = false;
          (<any>$('#alter_paginations')).DataTable().clear().destroy();
          setTimeout(()=>{
              (<any>$("#alter_paginations")).DataTable( {
                "pagingType": "full_numbers",
                "scrollX": '400px',
                "iDisplayLength": 25,
                dom: 'Blfrtip',
                "aaSorting": [],
                columnDefs: [ { type: 'date', 'targets': [4], "orderable": true } ],
                "scrollCollapse": false,
                buttons: {
                  buttons: [
                      { extend: 'copy', className: 'btn btn-default btn-rounded btn-sm mb-4', 
                      action: function () {
                        // Copy the table data to clipboard
                        var table = (<any>$("#alter_pagination")).DataTable();
                        var tableData = table.buttons.exportData().body;
                        var textData = '';
                        tableData.forEach((row:any) => {
                          textData += row.join('\t') + '\n';
                        });
                        const dummyTextarea = document.createElement('textarea');
                        dummyTextarea.textContent = textData;
                        document.body.appendChild(dummyTextarea);
                        dummyTextarea.select();
                        document.execCommand('copy');
                        document.body.removeChild(dummyTextarea);
          
                        $("#copyMessage").addClass("show");
                        setTimeout(() => {
                          $("#copyMessage").removeClass("show");
                        }, 2000);
                      }},
                      { extend: 'excel', className: 'btn btn-default btn-rounded btn-sm mb-4' },
                      { extend: 'print', className: 'btn btn-default btn-rounded btn-sm mb-4' }
                  ]
                },
                "language": {
                  "sProcessing": "Traitement en cours ...",
                  "sLengthMenu": "Afficher _MENU_ lignes",
                  "sZeroRecords": "Aucun résultat trouvé",
                  "sEmptyTable": "Aucune donnée disponible",
                  "sInfo": "",
                  "sInfoEmpty": "",
                  searchPlaceholder: "Saisir un mot clé",
                  "sInfoFiltered": "",
                  "sInfoPostFix": "",
                  "sSearch": "Rechercher:",
                  "sUrl": "",
                  "sInfoThousands": ",",
                  "sLoadingRecords": "Chargement...",
                  "oPaginate": {
                    "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
                  },
                  "oAria": {
                    "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
                  }
                },
                drawCallback: function () {
                  (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                        type: 'line',
                        width: '60',
                        height: '20',
                        lineColor: '#1a73e9',
                        fillColor: '#c2d5ff',
                        spotColor: 'transparent',
                        minSpotColor: 'transparent',
                        maxSpotColor: 'transparent',
                        highlightSpotColor: 'transparent',
                        highlightLineColor: 'transparent',
                    });
                }
            });
          }, 300);
        },
        (error) => {
          console.log(error);
          this.loading_sales = false  
        }
      );
      this.getCommercials();
      this.getCategories();
    }

    initList(){
      this.advancedSearchForm.reset();
      this.loading_sales = true;
      this.getSales();
    }

    advancedSearchRequest:any={};
    loading_sales_search:boolean=false;
    search(){
      ($('.collapse.show')as any).collapse('hide');
      let customerUUID = this.advancedSearchForm.value.customer;
      console.log(this.refClients);
      console.log(customerUUID);
      if (customerUUID!=="" && customerUUID!=null) {
        var matchingCustomer = this.refClients.find(client => client.uuid && client.uuid.toUpperCase().includes(customerUUID.toUpperCase()));      
        if (matchingCustomer) {
          customerUUID = matchingCustomer.uuid;
        }else {
          customerUUID=this.advancedSearchForm.value.customer;
        }
      }else {
        customerUUID=null;
      }
      this.advancedSearchForm.value.customer = customerUUID;

      let commercialUUID = this.advancedSearchForm.value.commercial; 
      
      if (commercialUUID!=="" && commercialUUID!==null) {
        const matchingCommercial = this.ourTeam.find(teamMember => teamMember.commercial_uuid && teamMember.commercial_uuid.toUpperCase().includes(commercialUUID.toUpperCase()));      
        if (matchingCommercial) {
          commercialUUID = matchingCommercial.commercial_uuid;
        }else {
          commercialUUID=this.advancedSearchForm.value.commercial;
        }
      }else {
          commercialUUID=null;
      }
      this.advancedSearchForm.value.commercial = commercialUUID;

      let categoryUUID = this.advancedSearchForm.value.sale_category;
      if (categoryUUID!=="" && categoryUUID != null) {
        const matchingCategory = this.categories.find(category => category.uuid && category.uuid.toUpperCase().includes(categoryUUID.toUpperCase()));
        if (matchingCategory) {
          categoryUUID = matchingCategory.uuid;
        }else {
          categoryUUID=this.advancedSearchForm.value.sale_category;
        }
      }else {
          categoryUUID=null;
        }
      this.advancedSearchForm.value.sale_category = categoryUUID;

      if ($("#roundedChk2").is(':checked')) {
        $("#roundedChk2").attr('value', 'true');
      } else {
        $("#roundedChk2").attr('value', 'false');
      }
      
      this.salesService.advancedSearchRequest = this.advancedSearchForm.value;    
      if(this.advancedSearchForm.value.customer=="" && this.advancedSearchForm.value.commercial=="" &&
        this.advancedSearchForm.value.sale_category==""&&
        (this.advancedSearchForm.value.start_date=="" || this.advancedSearchForm.value.end_date=="" )
        ){
        this.getSales();
      }else {            
        this.loading_sales_search = true;
        this.salesService.advancedSearchSales();
        this.advancedSearchRequest=this.salesService.advancedSearchSubject.subscribe(
          ( data: any ) => {
            this.loading_sales_search = false;
            if(data.code=="6525898e10b22b1606604de6218b26a2"){
              this.salesDataFiltred = data.sales;
              (<any>$('#alter_paginations')).DataTable().clear().destroy();
              setTimeout(()=>{
                (<any>$("#alter_paginations")).DataTable( {
                    "pagingType": "full_numbers",
                    "scrollX": '400px',
                    "aaSorting": [],
                    "iDisplayLength": 25,
                    columnDefs: [ { type: 'date', 'targets': [4], "orderable": true } ],
                    "scrollCollapse": false,
                    "language": {
                      "sProcessing": "Traitement en cours ...",
                      "sLengthMenu": "Afficher _MENU_ lignes",
                      "sZeroRecords": "Aucun résultat trouvé",
                      "sEmptyTable": "Aucune donnée disponible",
                      "sInfo": "",
                      "sInfoEmpty": "",
                      searchPlaceholder: "Saisir un mot clé",
                      "sInfoFiltered": "",
                      "sInfoPostFix": "",
                      "sSearch": "Rechercher:",
                      "sUrl": "",
                      "sInfoThousands": ",",
                      "sLoadingRecords": "Chargement...",
                      "oPaginate": {
                        "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
                      },
                      "oAria": {
                        "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
                      }
                    },
                    drawCallback: function () {
                      (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                            type: 'line',
                            width: '60',
                            height: '20',
                            lineColor: '#1a73e9',
                            fillColor: '#c2d5ff',
                            spotColor: 'transparent',
                            minSpotColor: 'transparent',
                            maxSpotColor: 'transparent',
                            highlightSpotColor: 'transparent',
                            highlightLineColor: 'transparent',
                        });
                    }
                });
              }, 500);
            }
          },
        )
      }
    }
  //#endregion
}
